// Random blog articles loader for home page with multi-language support

// Detectar idioma actual desde la URL
function getLang() {
    const path = window.location.pathname;
    if (path.startsWith('/en/')) return 'en';
    if (path.startsWith('/fr/')) return 'fr';
    if (path.startsWith('/de/')) return 'de';
    return 'es';
}

// Artículos del blog organizados por idioma
const blogArticlesByLanguage = {
    es: [],
    en: [],
    fr: [],
    de: []
};

const HOME_BLOG_CACHE_VERSION = 7;
const HOME_BLOG_POOL_TTL_MS = 1000 * 60 * 60 * 24 * 3; // 3 días
const HOME_BLOG_RECENT_MAX = 12;
const HOME_BLOG_MIN_POOL_SIZE = 12;
const HOME_BLOG_TARGET_POOL_SIZE = 24;
const HOME_BLOG_SAMPLE_SIZE = 80;
const HOME_BLOG_FETCH_CONCURRENCY = 6;
const HOME_BLOG_MAX_PATHS_TO_TRY = 200;

function shuffleArray(array) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
}

function cryptoRandomInt(max) {
    const m = Math.max(0, Number(max) || 0);
    if (m <= 1) return 0;
    try {
        const buf = new Uint32Array(1);
        window.crypto.getRandomValues(buf);
        return buf[0] % m;
    } catch {
        return Math.floor(Math.random() * m);
    }
}

function cryptoShuffle(array) {
    const newArray = Array.isArray(array) ? [...array] : [];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = cryptoRandomInt(i + 1);
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
}

function safeUrl(url) {
    if (!url || typeof url !== 'string') return '';
    try {
        const u = new URL(url, window.location.origin);
        const p = u.protocol.toLowerCase();
        if (p === 'http:' || p === 'https:') return u.href;
        return '';
    } catch {
        return '';
    }
}

function safePathOrUrl(url) {
    // Permite rutas relativas internas (e.g. /blog/...) o URLs http/https
    if (!url || typeof url !== 'string') return '';
    const s = url.trim();
    if (s.startsWith('/')) return s;
    return safeUrl(s);
}

function pickRandomUnique(items, count) {
    const arr = Array.isArray(items) ? items.filter(Boolean) : [];
    if (arr.length <= count) return [...arr];
    const out = [];
    const used = new Set();
    while (out.length < count && used.size < arr.length) {
        const idx = Math.floor(Math.random() * arr.length);
        if (used.has(idx)) continue;
        used.add(idx);
        out.push(arr[idx]);
    }
    return out;
}

async function mapWithConcurrency(items, concurrency, mapper) {
    const arr = Array.isArray(items) ? items : [];
    const limit = Math.max(1, Number(concurrency) || 1);
    const results = new Array(arr.length);
    let idx = 0;
    const workers = new Array(Math.min(limit, arr.length)).fill(0).map(async () => {
        while (true) {
            const i = idx++;
            if (i >= arr.length) return;
            try {
                results[i] = await mapper(arr[i], i);
            } catch {
                results[i] = null;
            }
        }
    });
    await Promise.all(workers);
    return results;
}

const CATEGORY_MAP = [
    { prefix: '/blog-gaming/', category: 'gaming', text: 'Gaming' },
    { prefix: '/blog-bodas/', category: 'bodas', text: 'Bodas' },
    { prefix: '/blog-cocina/', category: 'cocina', text: 'Cocina' },
    { prefix: '/blog-mascotas/', category: 'mascotas', text: 'Mascotas' },
    { prefix: '/blog-tecnologia/', category: 'tecnologia', text: 'Tecnología' },
    { prefix: '/blog/', category: 'blog', text: 'Blog' },
];

function deriveCategoryFromPath(pathname) {
    const p = String(pathname || '');
    // Coincidencia directa con prefijo conocido
    for (const entry of CATEGORY_MAP) {
        if (p.startsWith(entry.prefix)) {
            return { category: entry.category, categoryText: entry.text };
        }
    }
    // Rutas con prefijo de idioma (p.ej. /en/blog-tecnologia/...)
    const langPrefixMatch = p.match(/^\/(en|fr|de)\/(blog(?:-gaming|-bodas|-cocina|-mascotas|-tecnologia)?)\//i);
    if (langPrefixMatch) {
        const matched = '/' + langPrefixMatch[2] + '/';
        for (const entry of CATEGORY_MAP) {
            if (matched.startsWith(entry.prefix)) {
                return { category: entry.category, categoryText: entry.text };
            }
        }
    }
    return { category: '', categoryText: '' };
}

function pickDiverseArticles(pool, count) {
    const items = Array.isArray(pool) ? pool.filter(Boolean) : [];
    if (items.length <= count) return [...items];

    const buckets = new Map();
    items.forEach(it => {
        const u = String(it?.url || '');
        const c = String(it?.category || deriveCategoryFromPath(u).category || '');
        const key = c || 'other';
        if (!buckets.has(key)) buckets.set(key, []);
        buckets.get(key).push(it);
    });

    const categories = shuffleArray(Array.from(buckets.keys()));
    const selected = [];
    const pickedUrls = new Set();

    for (const cat of categories) {
        if (selected.length >= count) break;
        const arr = buckets.get(cat) || [];
        if (!arr.length) continue;
        const idx = Math.floor(Math.random() * arr.length);
        const it = arr[idx];
        const u = String(it?.url || '');
        if (!u || pickedUrls.has(u)) continue;
        pickedUrls.add(u);
        selected.push(it);
    }

    if (selected.length >= count) return selected.slice(0, count);

    const remaining = items.filter(it => {
        const u = String(it?.url || '');
        return u && !pickedUrls.has(u);
    });

    return selected.concat(pickRandomUnique(remaining, count - selected.length));
}

function normalizeExcerpt(text) {
    const s = String(text || '').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    if (s.length <= 180) return s;
    return s.slice(0, 177).trim() + '...';
}

async function fetchWithTimeout(url, timeoutMs) {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), timeoutMs);
    try {
        return await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
    } finally {
        clearTimeout(t);
    }
}

async function fetchWithTimeoutOpts(url, timeoutMs, opts) {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), timeoutMs);
    try {
        return await fetch(url, { ...(opts || {}), signal: controller.signal, credentials: 'same-origin' });
    } finally {
        clearTimeout(t);
    }
}

function pickArticlePreviewImage(doc, ogImg, twitterImg) {
    const genericOgPattern = /\/assets\/images\/blog-[^/]+-og\.(webp|png|jpe?g)$/i;
    const og = safeUrl(ogImg);
    const twitter = safeUrl(twitterImg);

    const contentImg = Array.from(doc.querySelectorAll('main img, article img, .article-image, .article-content img, img'))
        .map((img) => safeUrl(img?.getAttribute?.('src') || ''))
        .find((src) => {
            if (!src) return false;
            if (/flagcdn\.com/i.test(src)) return false;
            if (/favicon|icon|logo/i.test(src)) return false;
            return true;
        }) || '';

    if (genericOgPattern.test(og) && contentImg) return contentImg;
    if (genericOgPattern.test(twitter) && contentImg) return contentImg;
    return og || twitter || contentImg || '';
}

async function getBlogArticlePathsFromSitemap(currentLang) {
    const lang = String(currentLang || 'es');
    async function fetchPathsFrom(urlBase) {
        const url = `${urlBase}?v=${encodeURIComponent(String(HOME_BLOG_CACHE_VERSION))}`;
        const res = await fetchWithTimeoutOpts(url, 5000, { cache: 'no-store' });
        if (!res.ok) return [];
        const xmlText = await res.text();
        const doc = new DOMParser().parseFromString(xmlText, 'application/xml');
        const locNodes = Array.from(doc.getElementsByTagName('loc'));
        return locNodes
            .map(n => (n && n.textContent ? n.textContent.trim() : ''))
            .filter(Boolean)
            .map(loc => {
                try {
                    const u = new URL(loc, window.location.origin);
                    return u.pathname;
                } catch {
                    return '';
                }
            })
            .filter(Boolean)
            .filter(p => !p.endsWith('.html'))
            .filter(p => p !== '/' && p !== '/sitemap.xml')
            .filter(p => p !== '/blog/' && p !== '/blog/_plantilla-articulo/');
    }

    let paths = [];
    try {
        paths = await fetchPathsFrom('/sitemap.xml');
    } catch {
        paths = [];
    }

    const isBlogPost = (p) => {
        if (!p || typeof p !== 'string') return false;
        if (
            p.startsWith('/blog/') ||
            p.startsWith('/blog-gaming/') ||
            p.startsWith('/blog-bodas/') ||
            p.startsWith('/blog-cocina/') ||
            p.startsWith('/blog-mascotas/') ||
            p.startsWith('/blog-tecnologia/')
        ) return true;
        // Capturar rutas con prefijo de idioma (p.ej. /en/blog-tecnologia/)
        if (/^\/(en|fr|de)\/(blog|blog-gaming|blog-bodas|blog-cocina|blog-mascotas|blog-tecnologia)\//i.test(p)) return true;
        return false;
    };

    const blogPaths = paths.filter(isBlogPost);

    // Si el sitemap principal es “corto” y no incluye categorías (p.ej. solo /blog/),
    // intentamos el sitemap dentro del folder /frontend.
    const hasCategoryBeyondBlog = blogPaths.some(p =>
        p.startsWith('/blog-bodas/') ||
        p.startsWith('/blog-gaming/') ||
        p.startsWith('/blog-cocina/') ||
        p.startsWith('/blog-mascotas/')
    );
    if (!hasCategoryBeyondBlog) {
        try {
            const alt = await fetchPathsFrom('/frontend/sitemap.xml');
            if (alt && alt.length) paths = alt;
        } catch {
        }
    }

    const finalBlogPaths = paths.filter(isBlogPost);

    if (lang === 'es') {
        return finalBlogPaths.filter(p => !/^\/(en|fr|de)\//i.test(p) && !/\/(en|fr|de)\//i.test(p));
    }

    return finalBlogPaths.filter(p => new RegExp(`\\/${lang}\\/`, 'i').test(p));
}

async function fetchArticleMeta(pathname, currentLang) {
    const urlPath = safePathOrUrl(pathname);
    if (!urlPath) return null;

    const res = await fetchWithTimeout(urlPath, 5000);
    if (!res.ok) return null;
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const ogTitle = doc.querySelector('meta[property="og:title"]')?.getAttribute('content') || '';
    const ogDesc = doc.querySelector('meta[property="og:description"]')?.getAttribute('content') || '';
    const metaDesc = doc.querySelector('meta[name="description"]')?.getAttribute('content') || '';
    const ogImg = doc.querySelector('meta[property="og:image"]')?.getAttribute('content') || '';
    const twitterImg = doc.querySelector('meta[name="twitter:image"]')?.getAttribute('content') || '';
    const title = (ogTitle || doc.title || '').trim();
    if (!title) return null;
    const excerpt = normalizeExcerpt(metaDesc || ogDesc);
    const image = pickArticlePreviewImage(doc, ogImg, twitterImg);
    const cat = deriveCategoryFromPath(urlPath);
    return {
        title,
        excerpt,
        url: urlPath,
        image: image || 'https://cdn.publikaya.com/assets/images/placeholder-banner.webp',
        category: cat.category,
        categoryText: cat.categoryText
    };
}

function loadCachedPool(currentLang) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_pool_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const ts = Number(parsed?.ts || 0);
        const items = Array.isArray(parsed?.items) ? parsed.items : [];
        if (!ts || !items.length) return null;
        if (items.length < HOME_BLOG_MIN_POOL_SIZE) return null;
        const ageMs = Date.now() - ts;
        if (ageMs > HOME_BLOG_POOL_TTL_MS) return null;
        return items;
    } catch {
        return null;
    }
}

function saveCachedPool(currentLang, items) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_pool_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        localStorage.setItem(key, JSON.stringify({ ts: Date.now(), items: Array.isArray(items) ? items : [] }));
    } catch {
    }
}

function loadRecentUrls(currentLang) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_recent_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        const raw = localStorage.getItem(key);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        const urls = Array.isArray(parsed?.urls) ? parsed.urls : [];
        return urls.map(u => String(u || '')).filter(Boolean).slice(-HOME_BLOG_RECENT_MAX);
    } catch {
        return [];
    }
}

function saveRecentUrls(currentLang, urls) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_recent_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        const dedup = [];
        const seen = new Set();
        (Array.isArray(urls) ? urls : []).forEach(u => {
            const s = String(u || '');
            if (!s || seen.has(s)) return;
            seen.add(s);
            dedup.push(s);
        });
        localStorage.setItem(key, JSON.stringify({ ts: Date.now(), urls: dedup.slice(-HOME_BLOG_RECENT_MAX) }));
    } catch {
    }
}

function clearRecentUrls(currentLang) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_recent_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        localStorage.removeItem(key);
    } catch {
    }
}

function loadLastSelection(currentLang) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_last_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        const raw = localStorage.getItem(key);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        const urls = Array.isArray(parsed?.urls) ? parsed.urls : [];
        return urls.map(u => String(u || '')).filter(Boolean);
    } catch {
        return [];
    }
}

function saveLastSelection(currentLang, urls) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_last_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        const clean = (Array.isArray(urls) ? urls : []).map(u => String(u || '')).filter(Boolean);
        localStorage.setItem(key, JSON.stringify({ ts: Date.now(), urls: clean }));
    } catch {
    }
}

function loadRotationState(currentLang) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_rotation_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const urls = Array.isArray(parsed?.urls) ? parsed.urls.map(u => String(u || '')).filter(Boolean) : [];
        const idx = Number.isFinite(parsed?.idx) ? Number(parsed.idx) : 0;
        const ts = Number(parsed?.ts || 0);
        if (!urls.length) return null;
        return { urls, idx: Math.max(0, idx), ts };
    } catch {
        return null;
    }
}

function saveRotationState(currentLang, state) {
    try {
        const lang = String(currentLang || 'es');
        const key = `home_blog_rotation_v${HOME_BLOG_CACHE_VERSION}_${lang}`;
        const urls = Array.isArray(state?.urls) ? state.urls.map(u => String(u || '')).filter(Boolean) : [];
        const idx = Number.isFinite(state?.idx) ? Number(state.idx) : 0;
        localStorage.setItem(key, JSON.stringify({ ts: Date.now(), urls, idx }));
    } catch {
    }
}

function isSameUrlSet(a, b) {
    const aa = (Array.isArray(a) ? a : []).map(u => String(u || '')).filter(Boolean);
    const bb = (Array.isArray(b) ? b : []).map(u => String(u || '')).filter(Boolean);
    if (aa.length !== bb.length) return false;
    const sa = new Set(aa);
    if (sa.size !== aa.length) {
        // Si hay duplicados en A, normalizamos comparación por set
        const sb = new Set(bb);
        if (sa.size !== sb.size) return false;
        for (const u of sa) if (!sb.has(u)) return false;
        return true;
    }
    const sb = new Set(bb);
    if (sb.size !== bb.length) return false;
    if (sa.size !== sb.size) return false;
    for (const u of sa) if (!sb.has(u)) return false;
    return true;
}

function pickNextFromRotation(items, count, currentLang) {
    const arr = Array.isArray(items) ? items.filter(Boolean) : [];
    const urlsInPool = arr.map(it => String(it?.url || '')).filter(Boolean);
    if (!urlsInPool.length) return [];

    let state = loadRotationState(currentLang);
    if (!state || !isSameUrlSet(state.urls, urlsInPool)) {
        state = { urls: cryptoShuffle(urlsInPool), idx: 0, ts: Date.now() };
    }

    const selectedUrls = [];
    const maxSteps = Math.max(state.urls.length, 0);
    let cursor = Math.max(0, state.idx || 0);
    for (let step = 0; step < maxSteps && selectedUrls.length < count; step++) {
        const u = state.urls[cursor % state.urls.length];
        cursor++;
        if (!u) continue;
        if (selectedUrls.includes(u)) continue;
        selectedUrls.push(u);
    }

    state.idx = state.urls.length ? (cursor % state.urls.length) : 0;
    saveRotationState(currentLang, state);

    const map = new Map(arr.map(it => [String(it?.url || ''), it]));
    return selectedUrls.map(u => map.get(u)).filter(Boolean);
}

function sameSelection(a, b) {
    const aa = (Array.isArray(a) ? a : []).map(String);
    const bb = (Array.isArray(b) ? b : []).map(String);
    if (aa.length !== bb.length) return false;
    for (let i = 0; i < aa.length; i++) {
        if (aa[i] !== bb[i]) return false;
    }
    return true;
}

async function loadDynamicPool(currentLang) {
    const lang = String(currentLang || 'es');
    const cached = loadCachedPool(lang);
    if (cached && cached.length >= HOME_BLOG_MIN_POOL_SIZE) return cached;

    try {
        // Usar endpoint backend (reemplaza 24+ N+1 fetches de páginas HTML)
        const apiBase = (window.apiConfig && window.apiConfig.baseURL) || '/api/v1';
        const resp = await fetch(`${apiBase}/public/blog/preview?lang=${lang}&count=${HOME_BLOG_TARGET_POOL_SIZE}`);
        if (!resp.ok) return null;
        const data = await resp.json();
        const articles = (data.data && data.data.articles) || [];
        const valid = articles.filter(function(a) { return a && a.url && a.title; });

        if (valid.length >= HOME_BLOG_MIN_POOL_SIZE) {
            saveCachedPool(lang, valid);
        }
        return valid.length >= 3 ? valid : null;
    } catch {
        return null;
    }
}

async function loadRandomArticles() {
    const container = document.getElementById('randomBlogArticles');
    if (!container) return;
    
    // Detectar idioma actual
    const currentLang = getLang();
    
    let dynamicPool = null;
    try {
        dynamicPool = await loadDynamicPool(currentLang);
    } catch {
        dynamicPool = null;
    }

    // Fallback: si el API no responde, cargar desde sitemap.xml directamente
    if (!dynamicPool || dynamicPool.length < 3) {
        try {
            const sitemapFallback = await loadSitemapPool(currentLang);
            if (sitemapFallback && sitemapFallback.length >= 3) {
                dynamicPool = sitemapFallback;
            }
        } catch {
        }
    }

    // Si no hay artículos disponibles, ocultar la sección
    if (!dynamicPool || dynamicPool.length < 3) {
        try {
            container.replaceChildren();
            container.style.display = 'none';
            container.setAttribute('data-home-blog-version', String(HOME_BLOG_CACHE_VERSION));
            container.setAttribute('data-home-blog-source', 'none');
            container.setAttribute('data-home-blog-pool-size', String(Array.isArray(dynamicPool) ? dynamicPool.length : 0));
            container.setAttribute('data-home-blog-selected', '');
        } catch {
        }
        return;
    }

    try {
        container.style.display = '';
    } catch {
    }

    const source = 'sitemap';

    // Obtener artículos del idioma actual
    let articles = dynamicPool;
    
    const articlesToShow = [...articles];
    
    const recent = loadRecentUrls(currentLang);
    let available = articlesToShow.filter(a => {
        const u = String(a?.url || '');
        return u && !recent.includes(u);
    });
    if (available.length < 3) {
        clearRecentUrls(currentLang);
        available = articlesToShow;
    }

    const last = loadLastSelection(currentLang);
    let randomArticles = pickDiverseArticles(available, 3);
    if (randomArticles.length < 3) {
        randomArticles = pickNextFromRotation(available, 3, currentLang);
    }

    let tries = 0;
    while (tries < 6 && sameSelection(last, randomArticles.map(a => String(a?.url || '')))) {
        tries++;
        randomArticles = pickDiverseArticles(shuffleArray(available), 3);
        if (randomArticles.length < 3) {
            randomArticles = pickNextFromRotation(shuffleArray(available), 3, currentLang);
        }
    }
    const selectedUrls = randomArticles.map(a => String(a?.url || '')).filter(Boolean);
    saveLastSelection(currentLang, selectedUrls);
    saveRecentUrls(currentLang, recent.concat(selectedUrls));

    // Diagnóstico via DOM (sin console.log; útil cuando console-guard está activo)
    try {
        container.setAttribute('data-home-blog-version', String(HOME_BLOG_CACHE_VERSION));
        container.setAttribute('data-home-blog-source', source);
        container.setAttribute('data-home-blog-pool-size', String(Array.isArray(articles) ? articles.length : 0));
        container.setAttribute('data-home-blog-selected', selectedUrls.join(','));
        const rot = loadRotationState(currentLang);
        container.setAttribute('data-home-blog-rotation-idx', String(Number(rot?.idx || 0)));
    } catch {
    }
    
    // Traducciones para "Leer más"
    const readMoreText = {
        es: 'Leer más',
        en: 'Read more',
        fr: 'Lire plus',
        de: 'Mehr lesen'
    };
    
    container.replaceChildren();
    const frag = document.createDocumentFragment();
    const fallbackImg = 'https://cdn.publikaya.com/assets/images/placeholder-banner.webp';
    randomArticles.forEach(article => {
        const a = document.createElement('a');
        a.className = 'blog-card';
        a.href = safePathOrUrl(article.url) || '/blog.html';

        const img = document.createElement('img');
        img.className = 'blog-card-image';
        img.loading = 'lazy';
        img.src = safeUrl(article.image) || fallbackImg;
        img.alt = article.title ? String(article.title) : 'Artículo';
        img.addEventListener('error', () => { img.src = fallbackImg; }, { once: true });

        const content = document.createElement('div');
        content.className = 'blog-card-content';

        const cat = document.createElement('span');
        cat.className = `blog-card-category ${String(article.category || '')}`.trim();
        cat.textContent = article.categoryText ? String(article.categoryText) : '';

        const h3 = document.createElement('h3');
        h3.className = 'blog-card-title';
        h3.textContent = article.title ? String(article.title) : '';

        const p = document.createElement('p');
        p.className = 'blog-card-excerpt';
        p.textContent = article.excerpt ? String(article.excerpt) : '';

        const footer = document.createElement('div');
        footer.className = 'blog-card-footer';
        const span = document.createElement('span');
        span.textContent = readMoreText[currentLang] || readMoreText.es;
        const i = document.createElement('i');
        i.className = 'fas fa-arrow-right';
        footer.appendChild(span);
        footer.appendChild(i);

        content.appendChild(cat);
        content.appendChild(h3);
        content.appendChild(p);
        content.appendChild(footer);

        a.appendChild(img);
        a.appendChild(content);

        frag.appendChild(a);
    });
    container.appendChild(frag);
    
    console.log(`✅ Blog: Cargados ${randomArticles.length} artículos en ${currentLang} (${articles.length} únicos disponibles)`);
}

/**
 * Fallback: load articles directly from sitemap.xml (client-side, without API backend).
 * Used when the API endpoint is unreachable (e.g., production 403).
 */
async function loadSitemapPool(currentLang) {
    const lang = String(currentLang || 'es');
    try {
        // 1. Get article paths from sitemap, filtered by language
        const paths = await getBlogArticlePathsFromSitemap(lang);
        if (!paths || paths.length < 3) return null;

        // 2. Limit to a reasonable batch size
        const batch = paths.slice(0, HOME_BLOG_SAMPLE_SIZE || 20);

        // 3. Fetch metadata from each article page (with concurrency limit)
        const CONCURRENCY = HOME_BLOG_FETCH_CONCURRENCY || 6;
        const results = [];
        for (let i = 0; i < batch.length; i += CONCURRENCY) {
            const chunk = batch.slice(i, i + CONCURRENCY);
            const fetched = await Promise.allSettled(
                chunk.map(p => fetchArticleMeta(p, lang))
            );
            fetched.forEach(r => {
                if (r.status === 'fulfilled' && r.value && r.value.title) {
                    results.push(r.value);
                }
            });
        }

        if (results.length >= HOME_BLOG_MIN_POOL_SIZE) {
            saveCachedPool(lang, results);
        }
        return results.length >= 3 ? results : null;
    } catch {
        return null;
    }
}

// Load articles when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadRandomArticles);
} else {
    loadRandomArticles();
}
